<template>
  <v-layout v-if="show">
    <v-carousel 
      class="secondary"
      cycle
      :height="notHeight"
      hide-delimiter-background
      :show-arrows="notIndicators">  
      <v-carousel-item
        v-for="(item,i) in notImages"
        :key="i"
        :src="item.src" > 
          <v-overlay
            v-if="true"
            absolute >
            <v-layout v-if="notText"
             fill-height="" justify-center="" align-center="" column="" class="px-">
              <v-col sm="8" md="7" cols="12" >
                <v-layout fill-height="" justify-center="" align-center="" column>
                  <div class="not-f9 font-weight-black b1--text not-shadow text-center ">Sisters of St. Theresa of the Child Jesus</div>  
                  <div class="not-f7 font-weight-light b1--text not-shadow text-center">Congregation</div>   
                </v-layout> 
              </v-col>
            </v-layout>
          </v-overlay>
      </v-carousel-item>  
    </v-carousel>
  </v-layout>
</template>

<script>
import { timeout } from 'q';
export default {
  props:["not","notShow","notHeight","notText","notIndicators","notImages"],
  data: () => ({
    show:false,
    colors: [
       'indigo',
       'warning',
       'pink darken-2',
       'red lighten-1',
       'deep-purple accent-4',
     ],
     slides: [
       'First',
       'Second',
       'Third',
       'Fourth',
       'Fifth',
     ],
     
  }),
  mounted() {
    this.show = this.notShow
  },
  computed: {
    images(){
      let notImages = this.notImages
      return notImages
    }, 
  },
  watch: {
    notShow(v){
      this.show =v
    },
    notHeight(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100);

      
    }
  },
};
</script>
